import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "setup-domain-with-cloudflare"
    }}>{`Setup domain with CloudFlare`}</h2>
    <p><a parentName="p" {...{
        "href": "https://cloudflare.com"
      }}>{`Cloudflare.`}</a></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Get droplet IP on DigitalOcean`}</p>
        <p parentName="li"><img alt="DigitalOcean IP Address" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-digitalocean.png" /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Add `}<inlineCode parentName="p">{`A`}</inlineCode>{` and `}<inlineCode parentName="p">{`CNAME`}</inlineCode>{` to DNS on CloudFlare`}</p>
        <p parentName="li"><img alt="CloudFlare DNS" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-cloudflare.png" /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Set SSL to `}<inlineCode parentName="p">{`Flexible`}</inlineCode>{` on CloudFlare`}</p>
        <p parentName="li"><img alt="CloudFlare SSL" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cf-ssl.png" /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Turn on `}<inlineCode parentName="p">{`Always use HTTPS`}</inlineCode>{` on CloudFlare`}</p>
        <p parentName="li"><img alt="CloudFlare Always HTTPS" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cf-alway-https.png" /></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      